import { useTranslation } from 'hooks/useTranslation';
import {
  FacilitiesList,
  FacilitiesListItem,
  FacilitiesTableCellButtonContainer,
  TableRowCell,
  TableRowCellButton,
} from 'pages/Settings/pages/CustomFields/CustomFieldsSettingsComponent/CustomFieldsSettingsComponent.styled';

import { useState } from 'react';
import { MountTransition } from 'routes';

export function FacilitiesTableCell({
  isGrey,
  facilitiesList,
  isAll,
}: {
  isGrey?: boolean;
  facilitiesList: string[];
  isAll: boolean;
}) {
  const { t } = useTranslation();
  const [showFacilitiesList, setShowFacilitiesList] = useState(false);

  if (isAll) return <TableRowCell isGrey={isGrey}>All</TableRowCell>;
  if (facilitiesList.length === 1)
    return <TableRowCell isGrey={isGrey}>{facilitiesList[0]}</TableRowCell>;

  return (
    <TableRowCell isGrey={isGrey}>
      <FacilitiesTableCellButtonContainer>
        {facilitiesList.length} {t('location_settings:LOCATIONS')}
        <TableRowCellButton
          variant={'PurpleText'}
          onClick={() => setShowFacilitiesList(!showFacilitiesList)}
        >
          {showFacilitiesList ? t('settings:HIDE') : t('settings:SHOW')}
        </TableRowCellButton>
      </FacilitiesTableCellButtonContainer>
      {showFacilitiesList ? (
        <MountTransition component="span">
          <FacilitiesList>
            {facilitiesList.map((facility) => (
              <FacilitiesListItem key={facility}>{facility}</FacilitiesListItem>
            ))}
          </FacilitiesList>
        </MountTransition>
      ) : null}
    </TableRowCell>
  );
}
